import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_pause",
  "use": "icon-ic_pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_pause\">\n<g id=\"icon-ic_pause_ic_pause\">\n<path id=\"icon-ic_pause_Vector\" d=\"M6 3H8V21H6V3ZM16 3H18V21H16V3Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol